//Cambios en el mensaje de respuesta y reset del form por Cecilia 
import React, { useState, useEffect } from "react";
// Estilos
import Container from "./styled";
// Librerías
import { HiOutlineLocationMarker } from "react-icons/hi";
import { HiOutlineArrowLongRight } from "react-icons/hi2";
// Custom Hooks
import { useForm } from "../../../hooks/useForm";
// Form
import { contactoForm } from "../../../utils/formInitialValues";
import { contactoReglas } from "../../../utils/formRules";
// Mail
import { contactoMail } from "../../../utils/mailContent";
import { sendFormMail } from "../../../utils/sendFormMail";

export default function Conctacto() {
  // Custom Hooks
  // const { inputValues, handleChange, handleValidation, formErrors } = useForm(handleSubmit, contactoReglas, contactoForm);
  const { inputValues, handleChange, handleValidation, formErrors, setInputValues } = useForm(handleSubmit, contactoReglas, contactoForm);

  const [buttonMessage, setButtonMessage] = useState("Enviar");
  // [NUEVO] Estado para manejar el mensaje de feedback
  const [submitStatus, setSubmitStatus] = useState({
    show: false,
    message: "",
    isError: false
  });

  async function handleSubmit() {
    try {
      setButtonMessage("Enviando...");
      // [NUEVO] Resetear el estado de feedback al enviar
      setSubmitStatus({ show: false, message: "", isError: false });
      
      await sendFormMail(inputValues, null, contactoMail);
      
      setButtonMessage("Enviar");
      // [NUEVO] Mostrar mensaje de éxito
      setSubmitStatus({
        show: true,
        message: "¡Su mensaje ha sido enviado con éxito!",
        isError: false
      });
    } catch (error) {
      console.log(error);
      setButtonMessage("Enviar");
      // [NUEVO] Mostrar mensaje de error
      setSubmitStatus({
        show: true,
        message: "¡Error al enviar su mensaje!",
        isError: true
      });
    }
  }

  // EFECTO SECUNDARIO 
  useEffect(() => {
  if (submitStatus.show && !submitStatus.isError) {
    // Resetear los campos del formulario después del envío exitoso
    setInputValues(contactoForm);
  }
}, [submitStatus]);

  
  return (
    <Container name="contacto" id="contacto">
      {/* Section Max Width Container */}
      <section id="max-width-container">
        {/* Data Container */}
        <div id="data-container">
          {/* Tag Container */}
          <div id="tag-container">
            {/* Tag */}
            <div>
              <p>Contacto</p>
            </div>
          </div>
          {/* Title */}
          <h3>
            ¿Tenés <span>alguna consulta</span>?
          </h3>
          <h4>
            Escribinos o comunicate con nosotros, responderemos lo antes
            posible.
          </h4>
          <div className="text">
            Completá el siguiente formulario y envianos tu consulta, pronto
            nos comunicaremos con vos. También podes comunicarte por WhatsApp,
            correo electrónico o al 0800-220-2373.
          </div>
          <p id="adress">
            <span> 
              {/* icono de ubicacion  */}
              <HiOutlineLocationMarker></HiOutlineLocationMarker>
            </span>
            Suipacha 245 1°, CABA.
          </p>
        </div>
        {/* Formulario Container */}
        <div id="formulario-container">
          {/* Formulario */}
          <form>
            {/* Input Apellido */}
            <div className="input-container" id="input-apellido-container">
              <input
                type="text"
                id="input-apellido"
                name="apellido"
                onChange={handleChange}
                onFocus={handleChange}
                onBlur={handleChange}
                value={inputValues.apellido}
                className={formErrors.apellido == null ? "" : "input-error"}
                placeholder="Apellido"
              ></input>
            </div>
            {/* Input Nombre */}
            <div className="input-container" id="input-nombre-container">
              <input
                type="text"
                id="input-nombre"
                name="nombre"
                onChange={handleChange}
                onFocus={handleChange}
                onBlur={handleChange}
                value={inputValues.nombre}
                className={formErrors.nombre == null ? "" : "input-error"}
                placeholder="Nombre"
              ></input>
            </div>
            {/* Input Email */}
            <div className="input-container" id="input-email-container">
              <input
                type="email"
                id="input-email"
                name="email"
                onChange={handleChange}
                onFocus={handleChange}
                onBlur={handleChange}
                value={inputValues.email}
                className={formErrors.email == null ? "" : "input-error"}
                placeholder="Email"
              ></input>
            </div>
            {/* Input Telefono */}
            <div className="input-container" id="input-telefono-container">
              <input
                type="number"
                id="input-telefono"
                name="telefono"
                onChange={handleChange}
                onFocus={handleChange}
                onBlur={handleChange}
                value={inputValues.telefono}
                className={formErrors.telefono == null ? "" : "input-error"}
                placeholder="Teléfono"
              ></input>
            </div>
            {/* Textarea Mensaje */}
            <div className="input-container" id="textarea-mensaje-container">
              <textarea
                type="text"
                id="textarea-mensaje"
                name="mensaje"
                onChange={handleChange}
                onFocus={handleChange}
                onBlur={handleChange}
                value={inputValues.mensaje}
                className={formErrors.mensaje == null ? "" : "input-error"}
                placeholder="Ingresá tu mensaje"
              ></textarea>
            </div>
            <button type="submit" onClick={handleValidation}>
              {buttonMessage}
              <span>
                {/* icono flecha derecha  */}
                <HiOutlineArrowLongRight />
              </span>
            </button>
            
            {/* [NUEVO] Mensaje de feedback después del botón */}
            {submitStatus.show && (
              <div 
                className={`feedback-message ${submitStatus.isError ? 'error' : 'success'}`}
                style={{
                  marginTop: '1rem',
                  padding: '0.75rem',
                  borderRadius: '0.375rem',
                  backgroundColor: submitStatus.isError ? '#FEE2E2' : '#D1FAE5',
                  color: submitStatus.isError ? '#B91C1C' : '#065F46',
                  textAlign: 'center',
                  fontWeight: '500'
                }}
              >
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>
        <img id="background-image" alt="" src="/home/digitalizacion/curva.svg"></img>
      </section>
    </Container>
  );
}